import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import {
  AHIcon,
  AHText,
  Box,
  EmployeeAvatar,
  ListItem,
  SectionHeader,
  TouchableBox,
} from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { FormattedMessage } from "react-intl";
import { AccountEditAccountOwnerCard_employee$key } from "./__generated__/AccountEditAccountOwnerCard_employee.graphql";

export function AccountEditAccountOwnerCard(props: {
  employee: AccountEditAccountOwnerCard_employee$key | null;
  openConnectEmployee?: () => void;
  openEmployee?: (employeeId: string) => void;
}) {
  const employee = useFragment(
    graphql`
      fragment AccountEditAccountOwnerCard_employee on Employee {
        id
        name
        ...Avatar_employee
      }
    `,
    props.employee
  );
  const intl_tokens = useIntlTokens();
  return (
    <Box
      color="surface-primary"
      spaceHorizontal="medium"
      spaceVertical="medium"
    >
      <SectionHeader new>
        <SectionHeader.Title>{intl_tokens.Employee}</SectionHeader.Title>
      </SectionHeader>
      {!employee ? (
        <TouchableBox
          style={{
            flexDirection: "row",
            alignItems: "center",
            borderStyle: "dashed",
            borderWidth: 1,
          }}
          cornerRadius="large"
          space="medium"
          borderColor="negative"
          disabled={!props.openConnectEmployee}
          onPress={() => {
            props.openConnectEmployee?.();
          }}
        >
          <AHIcon
            type="guest-actor"
            color="text-secondary"
            size="large"
            spaceRight="small"
          />
          <AHText type="title-small" color="text-secondary" style={{ flex: 1 }}>
            <FormattedMessage
              defaultMessage="Missing"
              description="Missing account owner"
            />
          </AHText>
          <Box
            cornerRadius="medium"
            space="small"
            color="surface-backgroundControl"
          >
            <AHText type="subtitle">{intl_tokens.ConnectEmployee}</AHText>
          </Box>
        </TouchableBox>
      ) : (
        <TouchableBox
          style={{ flexDirection: "row", alignItems: "center", borderWidth: 1 }}
          cornerRadius="large"
          space="medium"
          borderColor="border-primary"
          disabled={!props.openEmployee}
          onPress={() => {
            if (employee) {
              props.openEmployee?.(employee.id);
            }
          }}
        >
          <EmployeeAvatar employee={employee} size="large" />
          <AHText spaceLeft="small" type="title-small" style={{ flex: 1 }}>
            {employee.name}
          </AHText>
          {props.openEmployee ? <ListItem.NavArrow /> : null}
        </TouchableBox>
      )}
    </Box>
  );
}
